module.exports = __webpack_public_path__ + "media/icons/delete-13e6a715.svg";